import { resolveStockItem } from "../composables/products/utils.mjs";
import { endOfDay, isAfter, isBefore } from "date-fns";
export function resolveProductPrice(product) {
  const specialPrice = product.special_price;
  const basePrice = product?.price_range?.maximum_price?.final_price.value ?? 0;
  if ((!product.special_from_date || !product.special_to_date) && specialPrice) {
    return specialPrice;
  }
  const offerFrom = product.special_from_date ? new Date(product.special_from_date) : null;
  const offerTo = product.special_to_date ? endOfDay(new Date(product.special_to_date)) : null;
  const now = /* @__PURE__ */ new Date();
  const isValidOffer = specialPrice && specialPrice !== null && offerTo && offerFrom && isAfter(offerTo, now) && isBefore(offerFrom, now);
  if (isValidOffer) {
    return specialPrice ?? basePrice;
  }
  return basePrice;
}
export function resolveProductStock(apiProduct) {
  if (apiProduct.__typename === "ConfigurableProduct") {
    return resolveStockItem(apiProduct);
  }
  if (["BundleProduct", "GroupedProduct"].includes(
    apiProduct.__typename
  )) {
    return apiProduct.only_x_left_in_stock === null ? 1e4 : apiProduct.only_x_left_in_stock;
  }
  return apiProduct.only_x_left_in_stock || 0;
}
export function isWeightedItem(product) {
  return product.cartControl.step % 1 !== 0;
}
export function resolvePricePerStep(price, step) {
  if (price === 0) {
    return null;
  }
  return price * step;
}
